import { Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import {
  StyledSection,
  StyledTitle,
  StyledDescription,
} from '../AiKnowledgeManagementSolutions.styles';
import { searchDatabaseData } from './SearchDatabase.data';
import Image from 'next/image';
import {
  SearchDatabaseWrapper,
  SearchDatabaseImageWrapper,
  SearchDatabaseTitle,
} from './SearchDatabase.styles';

export const SearchDatabase = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledSection width="small">
      <StyledTitle variant="display_sm">
        Search Your Entire Database in Seconds
      </StyledTitle>

      <StyledDescription
        sx={{
          textAlign: 'center',
          width: '100%',
          display: 'inline-block',
        }}
        variant="regular_500">
        Here's what happens when your knowledge management system is AI-powered
      </StyledDescription>

      <Grid container justifyContent="center" spacing={6} mt={6}>
        {searchDatabaseData.map(({ title, description, icon }, index) => (
          <Grid
            key={`searchDatabase-${index}`}
            size={{
              xs: 12,
              md: 6,
            }}>
            <SearchDatabaseWrapper>
              <SearchDatabaseImageWrapper>
                <Image
                  src={icon}
                  alt={title}
                  width={isMobile ? 16 : 24}
                  height={isMobile ? 16 : 24}
                />
              </SearchDatabaseImageWrapper>
              <Stack>
                <SearchDatabaseTitle variant="regular_400" color="#ffffff">
                  {title}
                </SearchDatabaseTitle>
                <StyledDescription>{description}</StyledDescription>
              </Stack>
            </SearchDatabaseWrapper>
          </Grid>
        ))}
      </Grid>
    </StyledSection>
  );
};
